var pageglobals = new PageGlobals();

window.events && events.listen(events.USER_JUST_LOGGED_IN, function () {
    controller.onLogin();
});

// similar to the events object, but:
//  - allows parameters to be passed to listener functions
//  - blocks calls to the "event", so that all listeners finish before execution flow returns to caller
var configureEvents = {
    // Invokes one listener and keeps the rest of the loop reachable. Listener
    // bodies belong to theme and site code this controller does not own, and
    // a throw in any of them used to end the loop: every listener registered
    // after it silently never ran for that event. On Smartpress that is how a
    // price read on a page with no price suppressed the Instant Proof mount
    // registered behind it. The failure is still reported, just not spread.
    invokeListener: function (eventName, listener, fn) {
        try {
            fn();
        } catch (e) {
            if (window.console && typeof console.error === 'function') {
                console.error('configureEvents.' + eventName + ': listener threw; remaining listeners still run', listener, e);
            }
        }
    },

    // CalcLoaded
    onCalcLoadedListeners: new Array(),
    registerOnCalcLoadedListener: function (listener) {
        if (listener != null && typeof listener == 'object' && typeof listener.onCalcLoaded == 'function') {
            this.onCalcLoadedListeners[this.onCalcLoadedListeners.length] = listener;
        } else {
            throw new TypeError('expected an object having onCalcLoaded function');
        }
    },

    // root function that calls registered listeners of CalcLoaded event.
    // listeners should have provide a function with signature "onCalcLoaded(coffering)"
    onCalcLoaded: function () {
        var coffering = this.getConfigGlobalsOffering();
        for (var i = 0, ni = this.onCalcLoadedListeners == null ? 0 : this.onCalcLoadedListeners.length; i < ni; i++) {
            var calcLoadedListener = this.onCalcLoadedListeners[i];
            this.invokeListener('onCalcLoaded', calcLoadedListener, function () {
                calcLoadedListener.onCalcLoaded(coffering);
            });
        }
    },

    // CalcChanged
    onCalcChangedListeners: new Array(),
    registerOnCalcChangedListener: function (listener) {
        if (listener != null && typeof listener == 'object' && typeof listener.onCalcChanged == 'function') {
            this.onCalcChangedListeners[this.onCalcChangedListeners.length] = listener;
        } else {
            throw new TypeError('expected an object having onCalcChanged function');
        }
    },

    // root function that calls registered listeners of CalcChanged event.
    // listeners should have provide a function with signature "onCalcChanged(cupdatedetails, coffering)"
    onCalcChanged: function (cupdatedetails) {
        var coffering = this.getConfigGlobalsOffering();
        for (var i = 0, ni = this.onCalcChangedListeners == null ? 0 : this.onCalcChangedListeners.length; i < ni; i++) {
            var calcChangedListener = this.onCalcChangedListeners[i];
            this.invokeListener('onCalcChanged', calcChangedListener, function () {
                calcChangedListener.onCalcChanged(cupdatedetails, coffering);
            });
        }
    },

    // QuoteUpdated (new quote from server)
    onQuoteUpdatedListeners: new Array(),
    registerOnQuoteUpdatedListener: function (listener) {
        if (listener != null && typeof listener == 'object' && typeof listener.onQuoteUpdated == 'function') {
            this.onQuoteUpdatedListeners[this.onQuoteUpdatedListeners.length] = listener;
        } else {
            throw new TypeError('expected an object having onQuoteUpdated function');
        }
    },

    // root function that calls registered listeners of QuoteUpdated event.
    // listeners should have provide a function with signature "onQuoteUpdated(cupdatedetails, validation, coffering)"
    onQuoteUpdated: function (cupdatedetails) {
        for (var i = 0, ni = this.onQuoteUpdatedListeners == null ? 0 : this.onQuoteUpdatedListeners.length; i < ni; i++) {
            var validation = null;
            if (window.common) {
                validation = common.validation;
            } else {
                validation = controller.validation;
            }
            var coffering = this.getConfigGlobalsOffering();
            var quoteUpdatedListener = this.onQuoteUpdatedListeners[i];
            this.invokeListener('onQuoteUpdated', quoteUpdatedListener, function () {
                quoteUpdatedListener.onQuoteUpdated(cupdatedetails, validation, coffering);
            });
        }
    },
    getConfigGlobalsOffering: function () {
        var coffering = null;
        if (configureglobals) {
            if (configureglobals.coffering) {
                coffering = configureglobals.coffering;
            } else {
                coffering = configureglobals.cstockoffering;
            }
        }
        return coffering;
    }
};

var confUtil = {
    // field types
    EF: 0,
    DD: 1,

    // categories
    FIELD_CHANGE: 'field change',
    INDEXED_FIELD_CHANGE: 'indexed field change',
    OPTION_CHANGE: 'option change',
    INIT: 'init',
    FULL_QUOTE: 'full quote',
    LOGIN: 'login',

    //
    getTypedFormItemValue: function (type, name, context) {
        if (type == 'EF') {
            return getFormItemValue(name, context);
        }
        if (type == 'DD') {
            return getDropDownSelectedValue(name, context);
        }
        return null;
    },
    getTypedFormItemText: function (type, name, context) {
        if (type == 'EF') {
            return getFormItemValue(name, context);
        }
        if (type == 'DD') {
            return getDropDownSelectedText(name, context);
        }
        return null;
    },
    generateDebugContentsFromDetails: function (details, context) {
        var content = '';
        if (isObject(details)) {
            if (hasValue(details.context)) {
                content += 'Context: ' + details.context + '\n';
            }
            if (hasValue(details.category)) {
                content += 'Category: ' + details.category + '\n';
                if (details.category == confUtil.FIELD_CHANGE) {
                    content += 'Field Name: ' + details.fieldName + '\n';
                    content += 'Field Value: ' + strWeb(confUtil.getTypedFormItemValue(details.fieldType, details.fieldName, context)) + '\n';
                } else if (details.category == confUtil.INDEXED_FIELD_CHANGE) {
                    var fieldName = details.fieldNamePrefix + details.fieldIndex;
                    content += 'Field Index: ' + details.fieldIndex + '\n';
                    content += 'Field Name: ' + fieldName + '\n';
                    content += 'Field Value: ' + strWeb(confUtil.getTypedFormItemValue(details.fieldType, fieldName, context)) + '\n';
                } else if (details.category == confUtil.OPTION_CHANGE) {
                    content += 'Value: ' + strWeb(details.value) + '\n';
                }
            }
        }
        return content;
    }
};

/*
//sample theme code - this would go into a theme file
var sampleThemeEventsContainerObject = {
    onCalcLoaded: function(coffering) {
        $("#side1Ink label").text("new text");
        // alert("quote is showing. offering name "+(coffering==null?null:"\""+strWeb(coffering.name)+"\""));
        console.log("quote is showing. offering:");
        console.log(coffering);
    },
    onCalcChanged: function(cupdatedetails, coffering) {
        // var content = confUtil.generateDebugContentsFromDetails(details, document);
        // alert("calculator values changed (before get new quote).\n"+content);
        console.log("calculator values changed (before get new quote).  {cupdatedetails,coffering}:");
        console.log({cupdatedetails:cupdatedetails,coffering:coffering});
    },
    onQuoteUpdated: function(cupdatedetails, validation, coffering) {
        // var content = confUtil.generateDebugContentsFromDetails(details, document);
        // alert("got new quote\n"+content);
        console.log("got new quote. {cupdatedetails,validation,coffering}:");
        console.log({cupdatedetails:cupdatedetails,validation:validation,coffering:coffering});
        var cvalidation = validation.cvalidation;
        if (cvalidation != null && cvalidation.hasMessages) {
            var content = '';
            if (cvalidation.hasGlobalMessages) {
                content += validation.generateGlobalMessages();
            }
            if (validation.hasJobQuoteFieldMessagesFor(cupdatedetails.fieldName)) {
                var fieldMessage = cvalidation.jobQuoteFieldMessages[0];
                // content += validation.generateJobQuoteFieldMessagesFor(cupdatedetails.fieldName);
                content += '\nField Name: ' + fieldMessage.fieldName + '\n';
                content += 'Field Message: ' + fieldMessage.value;
            }
            alert(content);
        }
    }
};
if (!window.console) console = {log:function(){}};
$(function(){
    configureEvents.registerOnCalcLoadedListener(sampleThemeEventsContainerObject);
    configureEvents.registerOnCalcChangedListener(sampleThemeEventsContainerObject);
    configureEvents.registerOnQuoteUpdatedListener(sampleThemeEventsContainerObject);
});
*/
